export const config = {
  data() {
    return {
      explainList: [
        {
          name: '湖北分公司',
          text:`<p>开票方式：下载楚税通APP</p>
          <p>名称：梧桐树保险经纪有限公司湖北分公司</p>
          <p>纳税人识别号：91420103MA4KUMYQ5F</p>`
        },
        {
          name: '深圳分公司',
          text:`<p>开票方式：深圳税务微信公众号</p>
          <p>户名：梧桐树保险经纪有限公司深圳分公司</p>
          <p>纳税人识别号：91440300MA5GTRUC1G</p>`
        },
        {
          name: '北京分公司',
          text:`<p>开票方式：去北京当地税务局开具发票</p>
          <p>户名：梧桐树保险经纪有限公司北京分公司</p>
          <p>纳税人识别号：91110105MA7G98A09P</p>`
        },
        {
          name: '广东分公司',
          text:`<p>开票方式：下载广东税务APP</p>
          <p>户名：梧桐树保险经纪有限公司广东分公司</p>
          <p>纳税人识别号：91440101MA9YAFT04L</p>`
        },
        {
          name: '江苏分公司',
          text:`<p>开票方式：下载江苏税务APP</p>
          <p>户名：梧桐树保险经纪有限公司江苏分公司</p>
          <p>纳税人识别号：91320104MA7L9BN04F</p>`
        },
        {
          name: '四川分公司',
          text:`<p>开票方式：下载四川税务APP</p>
          <p>户名：梧桐树保险经纪有限公司四川分公司</p>
          <p>纳税人识别号：91510105MABM6J4C57</p>`
        },
        {
          name: '陕西分公司',
          text:`<p>开票方式：下载陕西税务APP</p>
          <p>户名：梧桐树保险经纪有限公司陕西分公司</p>
          <p>纳税人识别号：91610132MABMXUT62H</p>`
        },
        {
          name: '河北分公司',
          text:`<p>开票方式：下载河北税务APP</p>
          <p>户名：梧桐树保险经纪有限公司河北分公司</p>
          <p>纳税人识别号：91130104MABQ19W47C</p>`
        },
        {
          name: '青岛分公司',
          text:`<p>开票方式：下载税税通APP</p>
          <p>户名：梧桐树保险经纪有限公司青岛分公司</p>
          <p>纳税人识别号：91370202MABPJJPM4G</p>`
        },
        {
          name: '江西分公司',
          text:`<p>开票方式：下载江西税务APP</p>
          <p>户名：梧桐树保险经纪有限公司江西分公司</p>
          <p>纳税人识别号：91360125MABU10E25J</p>`
        },
        {
          name: '总公司',
          text:`<p>开票方式：下载楚税通APP</p>
          <p>户名：梧桐树保险经纪有限公司</p>
          <p>纳税人识别号：91440000796298438D</p>`
        },
      ]
    };
  },
  mounted() {

  },
  methods: {}
};
